import DashboardReducer from './DashboardReducer';

export default from './DashboardContainer';
export const DashboardReducers = {
  DashboardReducer,
};
